import * as React from 'react';

type IconProps = React.SVGProps<SVGSVGElement> & { size?: number };
const base = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.75, strokeLinecap: 'round', strokeLinejoin: 'round' } as const;

export const HaloHeart: React.FC<IconProps> = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...base} {...props}>
    <path d="M12 21s-6.5-4.2-8.4-7.1c-1.7-2.5-.7-6 2.1-7.2 1.7-.7 3.7-.2 4.9 1.1 1.2-1.3 3.2-1.8 4.9-1.1 2.8 1.2 3.8 4.7 2.1 7.2C18.5 16.8 12 21 12 21z" />
    <ellipse cx="12" cy="5" rx="5.5" ry="1.8" />
  </svg>
);

export const Sparkle: React.FC<IconProps> = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...base} {...props}>
    <path d="M12 3l2.2 4.8L19 10l-4.8 2.2L12 17l-2.2-4.8L5 10l4.8-2.2L12 3z" />
    <path d="M4 4l1.2 2.6L8 8 5.2 9.4 4 12l-1.2-2.6L1 8l1.8-1.4L4 4z" />
    <path d="M20 14l.8 1.8L23 17l-2.2 1.2L20 20l-.8-1.8L17 17l2.2-1.2L20 14z" />
  </svg>
);

export const CloudStar: React.FC<IconProps> = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...base} {...props}>
    <path d="M8 19h8a4 4 0 0 0 0-8h-.4A5.6 5.6 0 0 0 6 9.8 3.8 3.8 0 0 0 6.5 17" />
    <path d="M12 8l.9 2 2 .9-2 .9-.9 2-.9-2-2-.9 2-.9.9-2z" />
  </svg>
);

export const ThirdEye: React.FC<IconProps> = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...base} {...props}>
    <path d="M2.5 12S6.5 6 12 6s9.5 6 9.5 6-3.9 6-9.5 6S2.5 12 2.5 12z" />
    <circle cx="12" cy="12" r="2.7" />
  </svg>
);

export const Candle: React.FC<IconProps> = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...base} {...props}>
    <path d="M10 22h4a1 1 0 0 0 1-1v-7a3 3 0 0 0-6 0v7a1 1 0 0 0 1 1z" />
    <path d="M12 5c1.3 0 2.3-1.1 2-2.3-.2-.7-.9-1.4-2-2.7-1.1 1.3-1.8 2-2 2.7C9.7 3.9 10.7 5 12 5z" />
  </svg>
);

export const OracleCard: React.FC<IconProps> = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...base} {...props}>
    <rect x="6.5" y="3" width="11" height="18" rx="2" />
    <path d="M14.5 5.5l-5 13" />
    <path d="M9 10h6" />
  </svg>
);

export const PinBoard: React.FC<IconProps> = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...base} {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M7 9h10M7 13h6" />
    <circle cx="12" cy="7" r="1" />
  </svg>
);

export const Coach: React.FC<IconProps> = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...base} {...props}>
    <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4z" />
    <path d="M4 21a8 8 0 0 1 16 0" />
  </svg>
);

/* Optional index export if you want a single import */
const MystaraOutline = { HaloHeart, Sparkle, CloudStar, ThirdEye, Candle, OracleCard, PinBoard, Coach };
export default MystaraOutline;
